
/**
 *
 * @param collection
 * @param iteratee
 * @return {{}}
 */
export const indexBy = (collection, iteratee) => {
    const indexed = {};
    const isFn = typeof iteratee === 'function';
    let hash = '';
    for (let item of collection ?? []) {
        hash = isFn ? iteratee(item) : item[iteratee];
        indexed[hash] = item;
    }
    return indexed;
};

/**
 * @param {array} collection
 * @param {function|string} keys
 * @param {function|string|null} values
 * @returns {{}}
 */
export const toDictionary = (collection, keys, values) => {
    const data = {};
    if (collection.length && collection.length > 0) {
        let key, value;
        for (let item of collection) {
            key = typeof keys === 'function' ? values(item, collection, data, keys, values) : item[keys];
            if (values) {
                value = typeof values === 'function' ? values(item, collection, data, keys, values) : item[values];
            } else {
                value = item;
            }
            data[key] = value;
        }
    }
    return data;
};

export const timeGroupsNames = {
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    week: 'Ten tydzień',
    older: 'Starsze',
};

export const groupByTime = (collection, timeField) => {
    const groups = {
        today: [],
        yesterday: [],
        week: [],
        older: [],
    };

    let date;
    const now = moment();
    const yesterday = moment().subtract(1, 'days');
    for (let item of collection) {
        date = moment(item[timeField]);
        if (date.isSame(now, 'day')) {
            groups.today.push(item);
        } else if (date.isSame(yesterday, 'day')) {
            groups.yesterday.push(item);
        } else if (date.isSame(now, 'week')) {
            groups.week.push(item);
        } else {
            groups.older.push(item);
        }
    }
    return groups;
};


/**
 *
 * @param {string|string[]} words
 * @returns {string[]}
 */
const prepareSearchFilterWords = words => {
    if (_.isArray(words)) {
        return words;
    }
    return String(words).toLowerCase().split(' ');
};


/**
 *
 * @param {object[]} collection
 * @param {string|string[]} searchQuery
 * @param {function|string} getSearchContext
 * @returns {*[]}
 */
export const doSearchFilter = (collection, searchQuery, getSearchContext) => {
    const words = prepareSearchFilterWords(searchQuery);
    return _.filter(collection, item => {
        return doSearchItemFilter(item, words, getSearchContext);
    });
};


/**
 *
 * @param {object} item
 * @param {string|string[]} searchQuery
 * @param {function|string} getSearchContext
 * @returns {boolean}
 */
export const doSearchItemFilter = (item, searchQuery, getSearchContext) => {
    const words = prepareSearchFilterWords(searchQuery);
    const searchContext = (_.isFunction(getSearchContext) ? String(getSearchContext(item, {words})) : String(item[getSearchContext])).toLowerCase();
    return words.every(word => searchContext.indexOf(word) !== -1);
};


/**
 *
 */
export const appendStoreItems = (store, items, itemsStateName, metaStateName, options = {}) => {
    const pageItemsField = options.pageItemsField || 'pageItemsIds';
    const itemPk = options.pk || 'id';
    const state = store.get(metaStateName, {});
    store.merge(itemsStateName, items);
    store.merge(metaStateName, {
        [pageItemsField]: _.uniq([
            ...items
                .filter(item => state[pageItemsField].indexOf(item[itemPk]) === -1)
                .map(m => m[itemPk]),
            ...state[pageItemsField],
        ]),
    });
}

/**
 * @param {[]} collections
 * @returns {[]}
 */
export const mergeCollections = (...collections) => {
    let pk = 'id';
    if (typeof collections[0] === 'string') {
        pk = collections.splice(0, 1);
    }

    const targetCollection = [];
    const previousItemsById = {};

    let previousItem;
    for (let collection of collections) {
        for (let item of collection) {
            previousItem = previousItemsById[item[pk]];
            if (previousItem) {
                targetCollection[targetCollection.indexOf(previousItem)] = {
                    ...previousItem,
                    ...item,
                };
            } else {
                targetCollection.push(item);
                previousItemsById[item[pk]] = item;
            }
        }
    }
    return targetCollection;
};

export const MOVE_ITEM_UP = -1;
export const MOVE_ITEM_DOWN = 1;

export const moveItemPosition = (collection, item, direction, onItemPositionChange, field = 'position') => {
    const previousPosition = item[field];
    const nextPosition = item[field] + direction;

    const otherModel = collection.filter(m => m[field] === nextPosition)[0];
    if (!otherModel) {
        return {item, collection};
    }

    const nextItem = {
        ...item,
        [field]: nextPosition,
    };

    const nextOtherItem = {
        ...otherModel,
        [field]: previousPosition
    };

    onItemPositionChange(nextItem);
    onItemPositionChange(nextOtherItem);
    return {
        item: nextItem,
        other: nextOtherItem,
        collection: mergeCollections(collection, [nextItem, nextOtherItem]),
    }
}

export const updateItemsPositions = (collection, onChange, field = 'position') => {
    let i = 1;
    const nextCollection = [];
    for (let item of _.sortBy(collection, m => m[field])) {
        if (item[field] !== i) {
            item[field] = i;
            onChange(item, i, collection);
        }
        nextCollection.push(item);
        i++;
    }
    return nextCollection;
}

export const swapIndices = (collection, fromIndex, toIndex) => {
    collection = Array.from(collection);
    collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
    return collection;
}
